import { apiGet, apiPost, apiPatch } from '@/lib/api';
import type { SupportTicket, SupportTicketReply } from '@/types/api';

export const supportApi = {
  list: () => apiGet<SupportTicket[]>('/support/tickets'),
  get:  (id: number) => apiGet<{ ticket: SupportTicket; replies: SupportTicketReply[] }>(`/support/tickets/${id}`),
  create: (data: { beschreibung: string; prioritaet: number; betreff?: string; attachments?: FormData }) => {
    if (data.attachments) {
      return apiPost<SupportTicket>('/support/tickets', data.attachments, { raw: true });
    }
    return apiPost<SupportTicket>('/support/tickets', data);
  },
  reply: (id: number, nachricht: string) => apiPost<SupportTicketReply>(`/support/tickets/${id}/replies`, { nachricht }),
  markRead: (id: number) => apiPatch(`/support/tickets/${id}/read`, {}),
  unreadCount: () => apiGet<{ count: number }>('/support/unread-count'),
};
